import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  changeSpeaker, setZoneAPI,
  sourceChange, setSourceForAll, setVolume,
  getSpeakerStatus
} from '../../../action/roomControlAction'
import { setLoadingMass, popupOpenClose } from '../../../action/action'
import { speakerList, changeVolume, speakerSetZoneAction, CLICKED, EXIT, CMSPath } from '../../../config/constant'
import SelectSpeaker from './selectSpeaker'
import DefaultImage from '../../../images/defaultAsset/bg_speaker_controls.png'
import $ from 'jquery'
import { scrollDownEffect,removeScrollDown, scrollUpEffect } from './scrollEffect';
import {withTranslation} from "react-i18next";
import { sendAnalytics } from '../../../action/homeAction'
import { calculateTimeDifference, getDefaultAnalyticsLabel } from '../../JS/utility'

class DemoSpeakerControl extends Component {
  constructor(props) {
    super(props);
    this.volumeTimeout = 0
    this.state = {
      currentSource: "BLUETOOTH",
      currentVolume: 50,
      widgetLaunchTime: new Date,
      widgetName: this.props.currentWidgets.displayName,
      selectedSpeaker : {
        "contollerName": "SOUND_BAR_InnSpire",
        "deviceUniqueId": "SOUND_BAR_InnSpire",
        "equipmentType": "SOUND_BAR",
        "ipAddress": "A.B.C.F",
        "uniqueIdentifier": "SB",
        "supportedSources": ['TV','BLUETOOTH'],
        "soundControlDetails": {
          "currentBass": null,
          "currentMusicStatus": null,
          "currentVolume": 18
        }
      }
    }
    this.appBodyPaddBottom = null;
  }

  volumeChange = (event) => {
    let volume = this.state.currentVolume
    let change = event.target.value - this.state.currentVolume;
    if (volume >= 0) {//this.state.selectedSpeaker.currentSource
      if(event.target.value > this.state.currentVolume){
        volume = volume + change;
      } else {
        volume = volume + change;
      }
      this.setState({ currentVolume: volume });
    }
    window.clearTimeout(this.volumeTimeout);
    // this.volumeTimeout = setTimeout((event) => {
    //   console.log("event", this.state.currentVolume);
    //   if (this.state.selectedSpeaker.currentSource) {
    //     //volChange = this.props.speakerSource.currentVolume - this.state.currentVolume
    //     if (this.props.guestDetail.locationId) {
    //       this.props.setVolume(
    //         this.state.currentVolume, changeVolume, this.state.selectedSpeaker,
    //         this.props.guestDetail, this.callBackFunction
    //       );
    //     } else {
    //       console.log("we are not getting location ID to get connect speaker.");
    //     }
    //   } else {
    //     this.props.popupOpenClose(true, "Input source is not selected.");
    //   }
    // }, 200);
  }

  callBackFunction = () => {
    // this.props.popupOpenClose(true, "sorry,can't connect to the speaker.");
    // this.setState({
    //   currentVolume:
    //     this.state.selectedSpeaker.currentVolume ?
    //       this.state.selectedSpeaker.currentVolume : 50
    // });
  }

  componentDidUpdate(prevProp) {
    if (this.state.selectedSpeaker &&
      prevProp.selectedSpeaker !== this.state.selectedSpeaker
      && this.state.selectedSpeaker.currentVolume) {
      this.setState({ currentVolume: this.state.selectedSpeaker.currentVolume })
    }
  }

  componentWillUnmount(){
    $('#app-body').css("padding-bottom",this.appBodyPaddBottom);
    removeScrollDown();

    // Send Analytics
    if(this.props.guestIsLoggedIn){
      let widgetCloseTime = new Date

      let duration = calculateTimeDifference(this.state.widgetLaunchTime, widgetCloseTime, 'second');
      let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
      this.props.sendAnalytics(
          this.props.guestDetail, 
          this.state.widgetName, 
          EXIT, 
          {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "duration": duration}, 
          0, 
          this.props.guestIsLoggedIn
      );
    }
    //
  }

  componentDidMount() {
    this.props.getSpeakerStatus("roomControl", this.props.guestDetail);
    this.appBodyPaddBottom = $('#app-body').css("padding-bottom");
    $('#app-body').css("padding-bottom","0");
    // scrollUpEffect("div.customOverlay",this.props.menuColor,10)
    
    // Send Analytics
    if(this.props.guestIsLoggedIn){
      let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
      this.props.sendAnalytics(
          this.props.guestDetail, 
          this.props.currentWidgets.displayName, 
          CLICKED, 
          {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget"}, 
          0, 
          this.props.guestIsLoggedIn
      );
    }
    //
  }

  speakerClick = (speaker) => {
    if (speaker) {
      this.setState({ currentVolume: speaker.currentVolume });
    }
    this.props.changeSpeaker(speaker);
  }

  playOnALL = () => {
    //console.log("value", document.getElementById("playOnAllSpeaker").checked)
    // if (this.state.selectedSpeaker.soundControlDetails.currentSource) {
      if (document.getElementById("playOnAllSpeaker").checked === true) {
        document.getElementById("playOnAllSpeaker").checked = false
        //console.log("@@@", this.state.selectedSpeaker);
        // this.props.setZoneAPI(
        //   this.props.guestDetail,
        //   this.state.selectedSpeaker,
        //   speakerSetZoneAction
        // );
        // this.props.setSourceForAll(this.state.selectedSpeaker.currentSource);
        // window.setTimeout(() => {
        //     this.callSpeakerStatusAPI();
        // }, 2000);
      } else {
        //document.getElementById("playOnAllSpeaker").checked = true;
        document.getElementById("playOnAllSpeaker").checked = true
        // this.props.popupOpenClose(true, "This is in progress so disconnecting speaker may not work.");
        // this.props.setSourceForAll(null);
      }
    // } else {
    //   this.props.popupOpenClose(true, "Plaese select source to play on all.");
    //   document.getElementById("playOnAllSpeaker").checked = false
    // }
  }

  changeSource = (source) => {
    this.props.setLoadingMass(true);
    if (source === "TV") {
    // //   this.props.sourceChange(
    // //     "changeSource", "TV", this.props.guestDetail,
        this.setState({currentSource:"TV"})
    // //     this.speakerConnectCallBack
    // //   );
    } else if (source === "BLUETOOTH") {
        this.setState({currentSource:"BLUETOOTH"})
        //   // this.props.sourceChange(
    //   //   "changeSource", "BLUETOOTH_OFF", this.props.guestDetail,
    //   //   this.state.selectedSpeaker,
    //   //   this.speakerConnectCallBack
    //   // );
     }// else {
    //   // this.props.sourceChange(
    //   //   "changeSource", "BLUETOOTH", this.props.guestDetail,
    //   //   this.state.selectedSpeaker,
    //   //   this.speakerConnectCallBack
    //   // );
    // }
  }

  speakerConnectCallBack = (status, controller) => {
    console.log("controller", controller)
    this.props.setLoadingMass(false);
    if (controller === "BLUETOOTH") {
      if (!status) {
        this.props.popupOpenClose(true, "Please connect to speaker from phone Bluetooth.");
        //  `Please connect to speaker from bluetooth setting with name "${this.state.selectedSpeaker.bluetoothName?this.state.selectedSpeaker.bluetoothName:""}"`);
      }
    }
    else if (controller === "BLUETOOTH_OFF") {
      if (!status) {
        this.props.popupOpenClose(true, "Sorry, can't able to Disconnected speaker bluetooth.");
      }
    } else {
      if (!status) {
        this.props.popupOpenClose(true, "Sorry, can't able to connect to speaker.");
      }
    }
  }

  goBack = () => {
    if (!this.state.selectedSpeaker) {
      this.props.changeSpeaker(null);
    } else {
      window.history.back()
    }
  }
  render() {

    scrollDownEffect(null,"speakerHeader",this.props.menuColor,3.6)
    const { t } = this.props
    return (
      <div
        style={/*this.state.selectedSpeaker ?
          {
            background: `url('${DefaultImage}') center center no-repeat`,
            backgroundSize: "cover", backgroundAttachment: "fixed", height: "100%"

          } :
          {
            background: `#292824 center center no-repeat`,
            backgroundSize: "cover", backgroundAttachment: "fixed", height: "100vh"
          }*/
          {
            backgroundImage: `linear-gradient(90deg, ${this.props.menuColor.assetBackgroundSelectorColor}66, rgba(255,255,255,0) ),url('${DefaultImage}')`,
            backgroundSize: "cover", 
            backgroundAttachment: "fixed", 
            height: "100vh",
            overflow:"scroll",
            backgroundRepeat:"no-repeat"
          } 
        
        }
      >{console.log('its speaker control')}
        <header id = "speakerHeader" class="inner-pages subpages no-background" >{/*style = {{backgroundColor:"transparent",boxShadow:"unset",border:"none",position:"sticky"}} */}
          <div className = "customOverlay" style = {{transition:"0.3s", position:"absolute",top:"0", left:"0", width: "100%", height:"85px", zIndex:"-1", background:"transparent"}}></div>
          <a
            onClick={this.goBack}
            class="button-back"></a>
          <div class="heading align-center">

            <div class="splash-brand">
                <img src={`${CMSPath}${this.props.logo}`} />
            </div>
            {/* <p class="bold" style = {{color: this.props.menuColor.assetFontSelectorColor,textShadow:"unset"}}>{this.props.currentWidgets.widgetTitle}</p> */}
          </div>
        </header>
        {this.state.selectedSpeaker ?
          <section id="tvControls" class="widgets padding-0 margin-0 container-bg" >

              <div class="widget-header widget-header-checkin">
                  { this.props.currentWidget.widgetHeaderImageUrl && 
                      <div class="widget-header-img">
                          <img src={`${CMSPath}${this.props.currentWidget.widgetHeaderImageUrl}`} alt={this.props.currentWidget.displayName} />
                      </div>
                  }
                  <div class="widget-header-title">{this.props.currentWidget.displayName}</div>
              </div>


            <div class="widgets">
              <div class="row evenrow padding-top-1 padding-bottom-1 padding-left-2 padding-right-2">
                <div class="col">
                  <div class="form-controls radio-controls">
                    <label>{t('room_control.speaker_control.play_audio')}</label>
                    <div class="radio-group">
                      <label class="radio" onClick={this.playOnALL}>
                        <input id="playOnAllSpeaker" type="radio" name="speakerUse" value="Speaker All" checked="true" />
                        <span class="radio-label">{t('room_control.speaker_control.all')}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row evenrow padding-bottom-1 padding-left-2 padding-right-2">
                <div class="col">
                  <div class="form-controls radio-controls">
                    <label>{t('room_control.speaker_control.source')}</label>
                    <div class="radio-group">
                      {
                        this.state.selectedSpeaker.supportedSources &&
                          this.state.selectedSpeaker.supportedSources.length > 0 ?
                          this.state.selectedSpeaker.supportedSources.map((iterator) => {
                            if (iterator !== "BLUETOOTH_OFF") {
                              return (
                                <label class="radio">
                                  <input type="radio" name="source" value={iterator}
                                    checked={ this.state.currentSource === `${iterator}`?true:"" } />
                                  <span class="radio-label" onClick={() => this.changeSource(iterator)}>
                                    {iterator}
                                  </span>
                                </label>
                              )
                            }
                          })
                          : null
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div class="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1 ch-controls">
                <div class="col">
                  <input
                    id="volRange"
                    type="range"
                    min={this.state.selectedSpeaker ?
                      this.state.selectedSpeaker.minimumVolume : 0}
                    max={this.state.selectedSpeaker ?
                      this.state.selectedSpeaker.maximumVolume : 100
                    }
                    onChange={this.volumeChange}
                    value={this.state.currentVolume}
                    class="range-slider speaker" />
                </div>
              </div>
              <div id="chControls" class="row padding-top-0 padding-bottom-1 padding-right-1 padding-left-1 ch-controls">
                {/* <div class="col ch-buttons ch-vertical">
                  <div class="button-container">
                    <button >
                      <i class="fas fa-plus"></i></button>
                  </div>
                </div> */}
                <div class="col ch-buttons ch-circle">
                  <input type="number" id="volumeValue" name="volumeValue" class="speaker-volume speaker" value={this.state.currentVolume} />
                  {/* we dont support mute button yet.
                  <button>
                    <i class="fas fa-volume-mute"></i>
                    <i class="fas fa-volume-up" style={{ display: "none" }}></i>
                  </button> */}
                </div>
                {/* <div class="col ch-buttons ch-vertical">
                  <div class="button-container">
                    <button><i class="fas fa-minus"></i></button>
                  </div>
                </div> */}
              </div>

            </div>
          </section>
          : <SelectSpeaker />
        }
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    currentPage: state.store2.roomControl.currentPage,
    guestDetail: state.store.home.guestDetails,
    // selectedSpeaker: state.store.roomControl.selectedSpeaker,
    speakerList: state.store.roomControl.speakerList,
    currentWidgets: state.store.sideNavBar.currentWidget,
    currentWidget: state.store.sideNavBar.currentWidget,
    logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
    speakerZone: state.store.roomControl.speakerZone,
    currentSongSource: state.store.roomControl.currentSongSource,
    menuColor: state.store.home.MenuColor,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currentHomePage: state.store2.currentHomePage,
  }
}
export default connect(
  mapStateToProps,
  {
    // setRegPage,
    // VDAStatusApi,
    // currentWidget,
    // setLoadingMass,
    // popupOpenClose,
    getSpeakerStatus,
    changeSpeaker,
    setZoneAPI,
    sourceChange,
    setVolume,
    setLoadingMass,
    setSourceForAll,
    popupOpenClose,
    sendAnalytics
  }
)(withTranslation('translations')(DemoSpeakerControl));